import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico, dineroDisabledMask, NotificacionMovimientosInventario } from "../../../Components/Items";
import { EditOutlined, CloseCircleOutlined, ShoppingCartOutlined, CarOutlined, DownloadOutlined } from "@ant-design/icons";
import GenerarVentaDeEmbarque from "./GenerarVentaDeEmbarque/GenerarVentaDeEmbarque";
import ModalDescargarDocumentos from "../../../Components/ModalDescargarDocumentos";
import descargarDocumentosMasivo, { MODULOS } from "../../../Components/DescargarDocumentosMasivo";

moment.locale("es");

class Embarques extends Component {
    tableRef = null;
    state = {
        todasEmbarques: [],
        loading: false,
        modalCancelacion: false,
        modalCancelacionId: null,
        modalGenerarVenta: false,
        modalGenerarVentaId: null,
        valor: 1,
        textoFiltro: "",
        totalRecords: 0,
        embarquesSeleccionados: [],
        objetoEmbarquesEncontrados: [],
        modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } },
    };

    consultarEmbarques(params) {
        this.setState({ loading: true });
        axios
            .post(
                "embarques/selectEmbarques",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    const embarques = res.data.data.map((value) => {
                        let numero = value.embarqueSerie + ' ' + value.embarqueNumero;
                        return {
                            ...value,
                            fechaEmbarque: value.fechaEmbarque,
                            numero: numero,
                            cliente: (value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)
                            ) + " - " + value.cliente.rfc,
                            clienteNombre: (value.cliente.persona
                                ? value.cliente.razonSocial
                                : (value.cliente.nombre + ' ' + value.cliente.apellidoPaterno + ' ' + value.cliente.apellidoMaterno)),
                            clienteClave: value.cliente.clave || '',
                            clienteNombreComercial: value.cliente.nombreComercial || '',
                            clienteRfc: value.cliente.rfc,
                            vendedor: value.vendedor ? (value.vendedor.nombre + " " + (value.vendedor.apellidoPaterno || "") + ' ' + (value.vendedor.apellidoMaterno || "")) : '',
                            accion: {
                                _id: value._id,
                                estado: value.estado,
                                estadoEntrega: value.estadoEntrega,
                                servicios: value.servicios,
                                createdAt: value.createdAt,
                            },
                        };
                    });
                    this.setState({
                        todasEmbarques: embarques,
                        totalRecords: res.data.totalRecords || 0,
                    });
                } else {
                    this.setState({ todasEmbarques: [], totalRecords: 0 });
                }
            })
            .catch((error) => {
                console.error('Error al consultar embarques:', error);
                this.setState({ loading: false });
            });
    }

    agregarEmbarque() {
        this.props.history.push("/panel/agregarEmbarque");
    }

    cerrarGenerarVentaDeEmbarque() {
        this.setState({
            modalGenerarVenta: false,
            modalGenerarVentaId: null,
        });
        if (this.tableRef) {
            this.tableRef.updateExternalFilters({ valor: this.state.valor });
        }
    }

    cancelarEmbarque(value) {
        axios
            .post(
                "embarques/cancelarEmbarque",
                { embarqueId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Embarque cancelado");
                    NotificacionMovimientosInventario(res.data.movimientosIds);
                } else if (res.data.success === 1) {
                    message.warn(res.data.message);
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    editarEmbarque(id) {
        this.props.history.push("/panel/editarEmbarque", { id });
    }

    entregarInsumosEmbarque(id) {
        this.props.history.push("/panel/entregarInsumosEmbarque", { id });
    }

    generarVentaDeEmbarque(id) {
        this.setState({
            modalGenerarVenta: true,
            modalGenerarVentaId: id,
        });
    }

    // La selección es libre: cualquier embarque se puede marcar, porque también
    // alimenta la descarga masiva. Que esté entregado completo y que todos sean
    // del mismo cliente se valida al usar Generar Venta.
    onSelectChange = (embarquesSeleccionados) => {

        let encontrarEmbarques = [];

        for (const embarqueId of embarquesSeleccionados) {
            const yaGuardado = this.state.objetoEmbarquesEncontrados.find(c => c._id?.toString() === embarqueId);
            if (yaGuardado) continue;
            const embarque = this.state.todasEmbarques.find(c => c._id?.toString() === embarqueId);
            if (embarque) encontrarEmbarques.push(embarque);
        }

        this.setState({ embarquesSeleccionados, objetoEmbarquesEncontrados: [...this.state.objetoEmbarquesEncontrados, ...encontrarEmbarques] });
    }

    generarVentaEmbarques() {
        const { embarquesSeleccionados } = this.state;
        if (embarquesSeleccionados.length === 0) {
            message.warn("No hay embarques seleccionados");
            return;
        }

        let clienteId = "";

        for (const embarqueId of this.state.embarquesSeleccionados) {
            let embarque = this.state.objetoEmbarquesEncontrados.find(c => c._id?.toString() === embarqueId);
            if (embarque) {
                if ((embarque.estado !== 1 && embarque.estado !== 2) || embarque.estadoEntrega !== 3) {
                    message.warn("Solo se pueden usar embarques entregados completamente");
                    return;
                }
                if (clienteId) {
                    if (clienteId !== embarque.clienteId?.toString()) {
                        message.warn("Los embarques seleccionados no pertenecen al mismo cliente");
                        return;
                    }
                } else {
                    clienteId = embarque.clienteId?.toString();
                }
            } else {
                message.warn("No se encontró el embarque seleccionado");
                return;
            }
        }

        this.props.history.push("/panel/agregarVenta", { embarquesSeleccionados });
    }

    abrirDescarga() {
        this.setState({ modalDescarga: { visible: true, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    cerrarDescarga() {
        this.setState({ modalDescarga: { visible: false, loading: false, progreso: { hechos: 0, total: 0 } } });
    }

    async confirmarDescarga(formatos) {
        this.setState((prev) => ({ modalDescarga: { ...prev.modalDescarga, loading: true } }));
        await descargarDocumentosMasivo({
            modulo: "embarque",
            ids: this.state.embarquesSeleccionados,
            empresaId: this.props.empresaId,
            headersToken: this.props.headersToken,
            ...formatos,
            onProgreso: (hechos, total) => this.setState((prev) => ({
                modalDescarga: { ...prev.modalDescarga, progreso: { hechos, total } },
            })),
        });
        this.cerrarDescarga();
    }

    render() {
        const columns = [
            {
                title: "Num",
                dataIndex: "numero",
                key: "numero",
                buscar: 'numero',
                render: (_, record) => (
                    <div>
                        <div style={{ fontSize: "12px", fontWeight: 500 }}>
                            {record.numero}
                        </div>
                        {record.ordenDeCompra && (
                            <div style={{ fontSize: "12px", color: "#666" }}>
                                OC: {record.ordenDeCompra}
                            </div>
                        )}
                    </div>
                ),
                width: 200,
                ellipsis: true,
            },
            {
                title: "OC",
                dataIndex: "ordenDeCompra",
                key: "ordenDeCompra",
                buscar: 'ordenDeCompra',
                responsive: [],
                width: 0,
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                responsive: ['md'],
                key: "proyecto",
                sorter: true,
                render: (value) => <span style={{ fontSize: "11px" }}>{value.nombre}</span>,
                width: "9%",
                ellipsis: true,
            },
            {
                title: "Cliente / Vendedor",
                dataIndex: "clienteNombre",
                key: "clienteNombre",
                buscar: "cliente",
                render: (_, record) => (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontSize: "12px", fontWeight: "bold" }}>
                            {record.clienteClave ? `${record.clienteClave} - ${record.clienteNombre}` : record.clienteNombre}
                        </span>
                        <span style={{ fontSize: "12px", color: "#666" }}>{record.vendedor || "-"}</span>
                    </div>
                ),
                width: window.innerWidth >= 1800 ? "21%" : "23%",
                ellipsis: true,
            },
            {
                title: "RFC",
                dataIndex: "clienteRfc",
                key: "clienteRfc",
                render: (value) => (
                    <div style={{ fontSize: "12px" }}>
                        {value}
                    </div>
                ),
                width: "8%",
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaEmbarque",
                responsive: ['md'],
                key: "fechaEmbarque",
                sorter: true,
                render: (value) => moment(value).locale('es').format("DD/MM/YY HH:mm"),
                width: window.innerWidth > 2000 ? 100 : 120,
                ellipsis: true,
                align: "center",
            },
            {
                title: "Subtotal / Total",
                dataIndex: "subtotal",
                key: "subtotal",
                responsive: ["md"],
                sorter: true,
                buscar: "subtotal",
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                            {dineroDisabledMask(record.subtotal)} {record.moneda}
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                            {dineroDisabledMask(record.total)} {record.moneda}
                        </div>
                    </div>
                ),
                width: 150,
                ellipsis: true,
                align: "right",
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                sorter: true,
                buscar: "total",
                responsive: [],
                width: 0,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                responsive: ['md'],
                key: "estado",
                render: (value, record) => {
                    let tag = null;
                    if (value === 0) {
                        tag = <Tag color="red" className="square-tag">Cancelada</Tag>;
                    } else if (value === 1) {
                        tag = <Tag color="blue" className="square-tag">Vigente</Tag>;
                    } else if (value === 2) {
                        tag = <Tag color="blue" className="square-tag">Pendiente</Tag>;
                    } else if (value === 3) {
                        tag = <Tag color="green" className="square-tag">Venta</Tag>;
                    }
                    let entregaTag = null;
                    if (value !== 0 && value !== 3) {
                        if (record.estadoEntrega === 3) {
                            entregaTag = <Tag color="green" className="square-tag">Entregado</Tag>;
                        } else if (record.estadoEntrega === 2) {
                            entregaTag = <Tag color="orange" className="square-tag">Parcial</Tag>;
                        }
                    }
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            {tag}
                            {entregaTag}
                        </div>
                    );
                },
                width: 120,
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: window.innerWidth > 1200 ? "right" : null,
                width: "12%",
                align: "center",
                onCell: () => ({
                    className: "acciones-sin-hover"
                }),
                render: (value) => {
                    if (value.estado === 0) return null;

                    let buttons = [];

                    const puedeEntregar = (value.estado === 1 || value.estado === 2) && value.estadoEntrega !== 3 && this.props.permisoEntregarEmbarques;
                    buttons.push(
                        <Tooltip title={puedeEntregar ? "Entregar Insumos" : "No disponible"} placement="top">
                            <span>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<CarOutlined />}
                                    onClick={() => this.entregarInsumosEmbarque(value._id)}
                                    disabled={!puedeEntregar}
                                >
                                </ButtonItem>
                            </span>
                        </Tooltip>
                    );

                    const puedeGenerarVenta = (value.estado === 1 || value.estado === 2) && value.estadoEntrega === 3 && this.props.permisoGenerarVentasEmbarques;
                    buttons.push(
                        <Tooltip title={puedeGenerarVenta ? "Generar Venta" : "Solo disponible cuando el embarque está entregado"} placement="top">
                            <span>
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    lima
                                    icon={<ShoppingCartOutlined />}
                                    onClick={() => this.generarVentaDeEmbarque(value._id)}
                                    disabled={!puedeGenerarVenta}
                                >
                                </ButtonItem>
                            </span>
                        </Tooltip>
                    );
                    const puedeEditar = (value.estado === 1 || value.estado === 2) && this.props.permisoEditarEmbarques;
                    buttons.push(
                        <Tooltip title={puedeEditar ? "Editar" : "No disponible para edición"} placement="top">
                            <ButtonItem
                                type="default"
                                size="small"
                                cyan
                                icon={<EditOutlined />}
                                onClick={() => puedeEditar && this.editarEmbarque(value._id)}
                                disabled={!puedeEditar}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    const puedeCancelar = value.estado !== 0 && value.estado !== 3 && this.props.permisoCancelarEmbarques;
                    buttons.push(
                        <Popconfirm
                            title="Seguro que quiere cancelar este embarque"
                            onConfirm={() => this.cancelarEmbarque(value._id)}
                            okText="Ok"
                            cancelText="Cancelar"
                            disabled={!puedeCancelar}
                        >
                            <Tooltip title={puedeCancelar ? "Cancelar" : "No se puede cancelar"} placement="top">
                                <ButtonItem
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<CloseCircleOutlined />}
                                    disabled={!puedeCancelar}
                                >
                                </ButtonItem>
                            </Tooltip>
                        </Popconfirm>
                    );

                    return <div className="acciones-container">{buttons}</div>;
                },
            },
        ];

        return (
            <>
                <PageHeader
                    title="Embarques"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            {window.innerWidth > 1000 &&
                                <SegmentedItem
                                    options={[
                                        { label: 'Vigente', value: 1 },
                                        { label: 'Pendiente', value: 2 },
                                        { label: 'Venta', value: 3 },
                                        { label: 'Cancelada', value: 4 },
                                        { label: 'Todos', value: 5 }
                                    ]}
                                    onChange={(value) => {
                                        if (this.tableRef) {
                                            this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                        }
                                        this.setState({ valor: value });
                                    }}
                                    value={this.state.valor}
                                />
                            }
                            {this.props.permisoAgregarEmbarques &&
                                <ButtonItem
                                    type="primary"
                                    key="agregarEmbarque"
                                    olivo
                                    onClick={this.agregarEmbarque.bind(this)}
                                    className="botonAgregar"
                                >
                                    Agregar Embarque
                                </ButtonItem>}

                            {(this.props.permisoVerEmbarques && this.state.embarquesSeleccionados.length > 0) &&
                                <ButtonItem
                                    blanco
                                    icon={<DownloadOutlined />}
                                    key="descargarEmbarques"
                                    onClick={this.abrirDescarga.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    Descargar ({this.state.embarquesSeleccionados.length})
                                </ButtonItem>}

                            {(this.props.permisoGenerarVentasEmbarques && this.state.embarquesSeleccionados.length > 0) &&
                                <ButtonItem
                                    type="primary"
                                    cyan
                                    key="generarVentaEmbarques"
                                    onClick={this.generarVentaEmbarques.bind(this)}
                                    style={{ fontSize: '14px', padding: '6.4px 15px', height: '32px' }}
                                >
                                    Generar Venta
                                </ButtonItem>}
                        </div>
                    }
                />

                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    onlyMineFilter
                    onRow={(record) => {
                        return {
                            onDoubleClick: () => {
                                if (this.props.permisoVerEmbarques) {
                                    this.props.history.push("/panel/verEmbarque", { id: record._id });
                                }
                            },
                        };
                    }}
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarEmbarques.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    scroll={{ x: "max-content" }}
                    dataSource={this.state.todasEmbarques}
                    columns={columns}
                    filterStorageKey={"embarquesFiltradosTabla" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                    setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
                    valorTextoDefault={""}
                    rowSelection={{
                        selectedRowKeys: this.state.embarquesSeleccionados,
                        onChange: this.onSelectChange.bind(this),
                        // La tabla pagina del lado del servidor: sin esto, antd
                        // tira las llaves de las páginas anteriores al paginar.
                        preserveSelectedRowKeys: true,
                    }}
                />

                <GenerarVentaDeEmbarque
                    visible={this.state.modalGenerarVenta}
                    id={this.state.modalGenerarVentaId}
                    cerrarGenerarVentaDeEmbarque={this.cerrarGenerarVentaDeEmbarque.bind(this)}
                />

                <ModalDescargarDocumentos
                    visible={this.state.modalDescarga.visible}
                    loading={this.state.modalDescarga.loading}
                    progreso={this.state.modalDescarga.progreso}
                    total={this.state.embarquesSeleccionados.length}
                    tieneXml={MODULOS.embarque.tieneXml}
                    onClose={this.cerrarDescarga.bind(this)}
                    onConfirm={this.confirmarDescarga.bind(this)}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoAgregarEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f9435654f5250e669a4a6f"
            )?.activado,
        permisoVerEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f943c654f5250e669a4a95"
            )?.activado,
        permisoCancelarEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f944be54f5250e669a4b37"
            )?.activado,
        permisoGenerarVentasEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f943e954f5250e669a4a9a"
            )?.activado,
        permisoEditarEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f9439954f5250e669a4a8c"
            )?.activado,
        permisoEntregarEmbarques:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "69f943ac54f5250e669a4a8d"
            )?.activado,
    };
};

export default connect(mapStateToProps)(Embarques);
